import { render } from "./add_department.vue?vue&type=template&id=02e8c53c"
import script from "./add_department.vue?vue&type=script&lang=js"
export * from "./add_department.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__